export const ufiGenericaOficioConfig = [
  {
    path: "/actuaciones/new/ufi-generica-oficio/initial",
    pathName: "ufi-generica-oficio",
    titulo: "UFI - DELITOS GENÉRICOS POR OFICIO",
    icon: "pi-building",
    roles: [
      "User Tester",
      "Super User",
      "Jefe de Dependencia",
      "Oficial Sumariante",
      "Jefe de Sumario",
    ],
    type: "link",
    grupo: "UFI",
    props: { formType: "ufi-generica-oficio", actuacionType: "ufi-generica-oficio" },
    nameOfRoute: "actuacion-initial",
  },
  {
    path: "/actuaciones/new/ufi-generica-oficio/initial/denunciante",
    pathName: "ufi-generica-oficio",
    titulo: "AFECTADOS",
    nameOfRoute: "actuacion-form-denunciante",
  },
  {
    path: "/actuaciones/new/ufi-generica-oficio/initial/momento",
    pathName: "ufi-generica-oficio",
    titulo: "FECHA, HORA y UBICACIÓN",
    nameOfRoute: "actuacion-form-momento",
  },
  {
    path: "/actuaciones/new/ufi-generica-oficio/initial/acusado",
    pathName: "ufi-generica-oficio",
    titulo: "VINCULADOS",
    nameOfRoute: "actuacion-form-acusado",
  },
  {
    path: "/actuaciones/new/ufi-generica-oficio/initial/efectos",
    pathName: "ufi-generica-oficio",
    titulo: "EFECTOS",
    nameOfRoute: "actuacion-form-efectos",
  },
];
